module.exports = __webpack_public_path__ + "img/feature_2.32ee582f.svg";